<template>
    <div class="navigation-tabs box g-py-0 g-px-3">
        <g-tabs :active-key="activeLink" :tab-bar-gutter="5" @change="handleClick">
            <g-tab-pane v-for="link in links" :key="link.routeName" :tab="link.text" />
        </g-tabs>
    </div>
</template>

<script>
    import { computed } from 'vue-demi';
    import useRouter from '../../../composables/use-router';
    import useEventTracking from '../../../composables/use-event-tracking';
    import { useContactStore, useAuthStore } from '../../../../stores';
    import useCurrentInstance from '../../../helpers/useCurrentInstance';
    import {
        EVENT_NAME_GENERAL_NAVIGATION_CLICK,
        EVENT_NAME_INSIGHTS_NAVIGATION_CLICKED
    } from '../../../../app-v2/constants/analytics-events';
    export default {
        /**
         * The component name
         *
         * @type {String}
         */
        name: 'NavigationTabs',
        setup(props, context) {
            const contact = useContactStore().data;
            const events = useEventTracking();
            const router = useRouter().get();
            const currentInstance = useCurrentInstance().$root;

            const showInsightState = computed(() => {
                return contact.has_discount_code || contact.has_affiliate_link;
            });

            const showPayouts = computed(() => {
                return (
                    (context.root.account_makes_payments || context.root.account_show_payouts_on_live_url) &&
                    useAuthStore().isLoggedIn &&
                    contact.last_verified_email
                );
            });
            const links = computed(() => {
                const linkData = [
                    {
                        text: 'Dashboard',
                        routeName: 'sponsorships'
                    }
                ];
                if (currentInstance.account_show_insights_on_live_url && showInsightState.value) {
                    linkData.push({
                        text: 'Insights',
                        routeName: 'insights'
                    });
                }
                linkData.push({
                    text: 'Networks',
                    routeName: 'manage.networks'
                });
                if (showPayouts.value) {
                    linkData.push({
                        text: 'Payouts',
                        routeName: 'payments.dashboard'
                    });
                }
                return linkData;
            });
            const activeLink = computed(() => context.root.$route.name);
            const handleClick = (routeName) => {
                const link = links.value.find((link) => {
                    return link.routeName === routeName;
                });
                const to = router.resolve({ name: routeName });
                if (routeName === 'insights') {
                    events.trackEvent(EVENT_NAME_INSIGHTS_NAVIGATION_CLICKED, {
                        dl_contact_id: contact.id
                    });
                } else {
                    events.trackEvent(EVENT_NAME_GENERAL_NAVIGATION_CLICK, {
                        link_text: link.text,
                        link_url: location.origin + to.href,
                        link_domain: location.host,
                        page_location: to.href
                    });
                }
                context.root.go(routeName);
            };
            return {
                activeLink,
                links,
                handleClick
            };
        }
    };
</script>

<style lang="scss" scoped>
    .navigation-tabs {
        height: 42px;
        padding: 0 24px;
    }
    ::v-deep .ant-tabs-nav .ant-tabs-tab-active {
        color: black !important;
    }
    ::v-deep .ant-tabs-bar {
        border-bottom: none;
    }
</style>
